import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DebuggerService {
  private static readonly DEBUG_MODE_KEY = 'debugMode';

  debugMode = new BehaviorSubject<boolean>(this.getDebugModeFromStorage());
  debugMode$ = this.debugMode.asObservable();

  constructor() {}

  private getDebugModeFromStorage(): boolean {
    const storedDebugMode = localStorage.getItem(
      DebuggerService.DEBUG_MODE_KEY
    );
    if (storedDebugMode=="undefined" || storedDebugMode==null) {
      return false;
    }
    return storedDebugMode ? JSON.parse(storedDebugMode) : false;
  }

  setDebugMode(debugMode: boolean): void {
    this.debugMode.next(debugMode);
    localStorage.setItem(
      DebuggerService.DEBUG_MODE_KEY,
      JSON.stringify(debugMode)
    );
  }
}
